import axios from "axios";

const state = {
      user: '',
      isAuthenticated: false
  }

const getters = {
    getCurrentUser: state => {
            return state.user
        },
    getUserStatus: state => {
            return state.isAuthenticated
        }
  }

const mutations = {
  setCurrentUser: (state, user) => {
      state.user = user
      state.isAuthenticated = true
    }
  }

const actions = {
   updateUser: ({commit}, payload) => {
       commit('setCurrentUser' , payload)
    }
  }

export default {
    state,
    getters,
    mutations,
    actions
  }



// WEBPACK FOOTER //
// ./src/store/modules/user.js